import React, { useMemo } from "react";
import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import "./processingSummaryTable.scss";

const ProcessingSummaryTableForCoa = ({
  data,
  columns,
  onRowClick,
  openDetailsPopUp,
  isApplicationUpdatedRow,
  type,
}) => {
  const memoData = useMemo(() => data, [type, data]);
  const memoCols = useMemo(() => columns, [type, columns]);

  const table = useReactTable({
    data: memoData,
    columns: memoCols,
    getCoreRowModel: getCoreRowModel(),
  });

  const rowClickHandler = onRowClick ?? openDetailsPopUp;
  const hasRowClick = typeof rowClickHandler === "function";

  const handleRowActivate = (row) => {
    if (!hasRowClick) return;
    rowClickHandler(row.original);
  };

  return (
    <div className="processing-summary-table-container">
      <table className="table">
        <thead className="thead">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, idx) => {
                const isFirst = idx === 0;
                const style = {
                  fontSize: "13px",
                  fontWeight: "normal",
                  paddingLeft: isFirst ? "10px" : "0px",
                  textAlign: isFirst ? "left" : "center",
                  backgroundColor: "white",
                  color: "black",
                };
                return (
                  <th key={header.id} style={style}>
                    <p style={{ padding: "10px 0" }}>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </p>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>

        <tbody className="tbody">
          {table.getRowModel().rows.map((row, rowIdx) => {
            const isUpdatedRow = isApplicationUpdatedRow?.(row.original);
            const rowStyle = {
              borderBottom: "1px solid #DFDFDF",
              borderTop: "1px solid #DFDFDF",
              fontSize: "13px",
              textAlign: "center",
              fontWeight: "normal",
              backgroundColor: rowIdx % 2 === 0 ? "#d5e5ff" : "white",
              cursor: hasRowClick ? "pointer" : "default",
            };

            return (
              <tr
                key={row.id}
                className={isUpdatedRow ? "coa-application-updated-row" : undefined}
                style={rowStyle}
                onClick={() => handleRowActivate(row)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleRowActivate(row);
                  }
                }}
                tabIndex={hasRowClick ? 0 : undefined}
                role={hasRowClick ? "button" : undefined}
                title={
                  isUpdatedRow
                    ? "Click row to view application update details"
                    : undefined
                }
              >
                {row.getVisibleCells().map((cell, cellIdx) => {
                  const isFirst = cellIdx === 0;
                  const isDate = cellIdx === 2;
                  const cellStyle = {
                    borderBottom: "1px solid #DFDFDF",
                    borderTop: "1px solid #DFDFDF",
                    fontSize: "0.75vw",
                    textAlign: isFirst ? "left" : "center",
                    paddingLeft: isFirst ? "10px" : "0px",
                    width: isDate ? "50px" : "100px",
                  };
                  return (
                    <td key={cell.id} style={cellStyle}>
                      <p style={{ padding: "0", minHeight: "40px" }}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProcessingSummaryTableForCoa;
